import React, { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { NotificationManager } from 'react-notifications';
import isEmpty from 'lodash/isEmpty';
import { GQL_ENABLE_PAYMENT_METHOD_FOR_FLOW } from '../../../../utils/queries/flows/flowSettings/mutations';
import { usePaymentFlowContext } from '../../paymentFlowContext';
import { TOAST_TIMEOUT, TOAST_TITLE } from './useHandleAddToFlow';
import { isDefined } from '../../../../utils/helpers';
import ToastCustomContainer from '../../../../components/ToastCustomContainer';

const useEnablePaymentMethodsForPaymentFlow = () => {
  const [setCheckoutType, { loading }] = useMutation(GQL_ENABLE_PAYMENT_METHOD_FOR_FLOW);
  const { flow, setSaving, setFlow } = usePaymentFlowContext();
  const handleEnablePaymentMethod = useCallback(
    async (connectionId, methods) => {
      setSaving(true);
      try {
        const res = await setCheckoutType({
          variables: {
            flowId: flow?.id,
            connectionId,
            methods,
          },
        });
        if (!isEmpty(res?.errors)) {
          NotificationManager.error(
            <ToastCustomContainer message={res?.errors[0]?.message} title={TOAST_TITLE} />,
            null,
            TOAST_TIMEOUT
          );

          return;
        }
        if (isDefined(res?.data?.enablePaymentMethodsForPaymentFlow)) {
          setFlow(res.data.enablePaymentMethodsForPaymentFlow);
          return;
        }
        NotificationManager.error(
          <ToastCustomContainer message="uiMessages.error" title={TOAST_TITLE} />,
          null,
          TOAST_TIMEOUT
        );
      } catch {
        NotificationManager.error(
          <ToastCustomContainer message="uiMessages.error" title={TOAST_TITLE} />,
          null,
          TOAST_TIMEOUT
        );
      } finally {
        setSaving(false);
      }
    },
    [setCheckoutType, flow, setSaving, setFlow]
  );

  return { handleEnablePaymentMethod, loading };
};

export { useEnablePaymentMethodsForPaymentFlow };
